import { parseQueryStrings } from "@crehana/utils";
import { UpperFunnelJobToBeDoneEnum, UpperFunnelSourceEnum } from "./types.js";
const getUserTrackingIntent = ()=>{
    const qs = window.location.search;
    const { upperFunnelJobToBeDone: jobToBeDone, upperFunnelSource: source } = parseQueryStrings(qs) || {};
    if ('string' == typeof jobToBeDone && Object.values(UpperFunnelJobToBeDoneEnum).includes(jobToBeDone) && 'string' == typeof source && Object.values(UpperFunnelSourceEnum).includes(source)) return {
        jobToBeDone: jobToBeDone,
        source: source,
        urlSource: window.location.href
    };
};
export { getUserTrackingIntent };
